import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
    standalone: false
})
export class OrderComponent implements OnInit {
  isDesktop: boolean;

  constructor(
    protected deviceService: DeviceDetectorService,
  ) { }

  ngOnInit(): void {
    this.isDesktop = this.deviceService.isDesktop();
  }

}
